export enum AppTheme {
    Light = 'light',
    Dark = 'dark',
}

export const APP_THEME_STORAGE_KEY = 'color-scheme';
